module.exports = __webpack_public_path__ + "img/ammeter.093b06bb.png";